import httpClient from '../../services/httpClient';

export const useApi = () => ({
  validateToken: async (token: string) => {
    const response = await httpClient.post('/validate', { token });
    return response.data;
  },

  signin: async (cpf: string, senha: string) => {
    const response = await httpClient.post('/api/auth/login', {
      cpf,
      senha,
    });
    return response.data;
  },

  logout: async () => {
    const response = await httpClient.post('/api/auth/logout');
    return response.data;
  },
});
